"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class PrivateRoute extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "render", () => {
      const {
        auth,
        render,
        component,
        redirect,
        location,
        generalSettings,
        ...rest
      } = this.props;
      const Component = render || component;
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, _extends({}, rest, {
        render: props => {
          return auth.state === 'LOGGED_IN' ? /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
            auth: auth,
            generalSettings: generalSettings
          })) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
            to: {
              pathname: redirect,
              state: {
                from: location
              }
            }
          });
        }
      }));
    });
  }
}
var _default = exports.default = PrivateRoute;
module.exports = exports.default;